<template>
  <div :key="step" :class="{ 'p-9': !disablePadding }">
    <Loader v-if="step < 0" />

    <!-- Отправка телефона -->
    <template v-if="step === 0">
      <bim-text
        type="main"
        bold
        class="mb-6"
        v-html="welcomeTitle || $bimTranslate('phoneValidate.step0.title', activeLang)"
      />
      <bim-text
        class="mb-2"
        type="medium"
        v-html="welcomeDesc || $bimTranslate('phoneValidate.step0.desc', activeLang)"
      /><bim-text
        class="mb-6"
        type="medium"
        v-html="
          welcomeWarn ||
          'Если у вас операторы Kcell, Beeline KZ или Беларусь, код верификации придет на вашу почту, указанную при регистрации.'
        "
      />
      <bim-input
        class="phone mb-6"
        mask="phone"
        v-model="phoneValue"
        formKey="phoneValue"
        :formModel="_self"
      />
      <!-- капча -->
      <vue-recaptcha
        ref="recaptcha"
        size="invisible"
        :sitekey="sitekey"
        :loadRecaptchaScript="true"
        @verify="sendSMS"
        @expired="onCaptchaExpired"
      />
      <!--      <div class="agreement mb-6">-->
      <!--        Направляя свои персональные данные, я даю-->
      <!--        <a href="https://bimlib.pro/agreement/" target="_blank">согласие</a> на их обработку-->
      <!--      </div>-->
      <bimCheckbox
        class="agreement mb-6"
        v-model="agreement"
      >
      <span>
        Направляя свои персональные данные, я даю
        <a
          href="https://bimlib.pro/agreement/"
          target="_blank"
        >
          согласие
        </a>
        на их обработку
      </span>
      </bimCheckbox>
      <div style="text-align: right">
        <bim-button
          @click="validateCapcha"
          :disabled="!$v2.validForm || lockButton || !agreement"
          class="buttons__item"
          >{{ $bimTranslate("phoneValidate.sendCode", activeLang) }}</bim-button
        >
      </div>
    </template>

    <!-- Отправка кода -->
    <template v-if="step === 1">
      <bim-text type="main" bold class="mb-6">{{
        $bimTranslate("phoneValidate.step1.title", activeLang)
      }}</bim-text>
      <bim-text class="mb-6" type="medium">
        {{ $bimTranslate("phoneValidate.step1.desc", activeLang) }} <br />{{ phoneValue }}.
        <span v-show="countdown > 0">
          {{ $bimTranslate("phoneValidate.step1.descRefresh", activeLang) }} {{ countdown }}
          {{ $bimTranslate("phoneValidate.step1.seconds", activeLang) }}
        </span>
        <span v-show="countdown <= 0" class="refresh" @click="validateSecondCapcha">{{
          $bimTranslate("phoneValidate.step1.refreshSend", activeLang)
        }}</span>
      </bim-text>
      <!-- капча -->
      <vue-recaptcha
        ref="recaptcha2"
        size="invisible"
        :sitekey="sitekey"
        :loadRecaptchaScript="true"
        @verify="sendSMS"
        @expired="onSecondCaptchaExpired"
      />
      <bim-input class="phone mb-6" placeholder="____" mask="0000" v-model="codeValue" />
      <bim-text v-if="errorText" class="mb-6" style="color: red" type="desc">{{
        errorText
      }}</bim-text>
      <div class="buttons">
        <bim-button @click="goBack" :disabled="timerButton" class="buttons__item mr-6" color="gray">
          <span>{{ $bimTranslate("phoneValidate.changeNumber", activeLang) }}</span>
          <span v-if="step === 1 && timerButton" class="timer">|{{ formattedTimer }}</span>
        </bim-button>
        <bim-button
          @click="sendVerificationCode"
          :disabled="codeValue.length !== 4"
          class="buttons__item"
          >{{ $bimTranslate("phoneValidate.sendCode", activeLang) }}</bim-button
        >
      </div>
    </template>

    <!-- Успешная отработка -->
    <template v-if="step === 2">
      <bim-text type="main" bold class="mb-6">{{
        $bimTranslate("phoneValidate.step2.title", activeLang)
      }}</bim-text>
      <bim-text class="mb-6" type="medium">{{
        $bimTranslate("phoneValidate.step2.desc", activeLang)
      }}</bim-text>
    </template>

    <!-- Ошибка, что телефон уже подтвержден -->
    <template v-if="step === 3">
      <bim-text type="main" bold class="mb-6">{{
        $bimTranslate("phoneValidate.step3.title", activeLang)
      }}</bim-text>
      <bim-text class="mb-6" type="medium">{{
        $bimTranslate("phoneValidate.step3.desc", activeLang)
      }}</bim-text>
    </template>
  </div>
</template>

<script>
import Loader from '@/components/core/loader'
import bimText from '@/components/text/bimText/bimText'
import bimInput from '@/components/form/bimInput/bimInput'
import bimButton from '@/components/form/bimButton/bimButton'
import bimCheckbox from '@/components/form/bimCheckbox/bimCheckbox'
import VueRecaptcha from 'vue-recaptcha'

export default {
  name: 'formPhoneVerification',
  components: {
    bimText,
    bimInput,
    bimButton,
    Loader,
    VueRecaptcha,
    bimCheckbox,
  },
  props: {
    /**
     * Логирующая функция для /log/event/
     */
    logActionEvent: {
      type: Function,
      default: () => {},
    },
    /**
     * объект контекста пользователя
     */
    user: {
      type: Object,
      default: () => ({}),
    },
    /**
     * текущий язык
     */
    activeLang: {
      type: String,
      default: 'ru',
      validator (value) {
        return ['ru', 'en'].indexOf(value) !== -1
      },
    },
    /**
     * отключить отступы
     */
    disablePadding: Boolean,
    /**
     * Приветственный заголовок (на первом этапе)
     * */
    welcomeTitle: {
      type: String,
      default: '',
    },
    /**
     * Приветственное описение (на первом этапе)
     * */
    welcomeDesc: {
      type: String,
      default: '',
    },
    welcomeWarn: {
      type: String,
      default: '',
    },
    /**
     * captcha siteKey
     */
    sitekey: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    step: -1,
    phoneValue: '7',
    codeValue: '',
    countdown: 0,
    countdownTimer: null,
    errorText: '',
    lockButton: false,
    showCaptcha: false,
    timerButton: false,
    timer: 90,
    timerInterval: null,
    agreement: false
  }),
  computed: {
    formValidation () {
      return { phoneValue: ['required', 'phone'] }
    },
    toastSettings () {
      return { duration: 0 }
    },
    formattedTimer () {
      const minutes = Math.floor(this.timer / 60)
      const seconds = this.timer % 60
      return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`
    },
  },
  async mounted () {
    const resp = await this.$user.getPhone()
    if (resp.phone) {
      this.phoneValue = resp.phone
    }
    if (resp.validated) {
      this.step = 3
    } else {
      setTimeout(() => {
        this.step = 0
        this.$forceUpdate()
        this.$emit('loaded', true)
      }, 500)
    }
  },
  destroyed () {
    if (this.countdownTimer) {
      this.clearCountdownTimer()
    }
  },
  watch: {
    countdown (time) {
      if (time <= 0) {
        this.clearCountdownTimer()
      }
    },
    step (newStep) {
      if (newStep === 1) {
        this.timerButton = true
        this.startTimer()
      }
    },
  },
  methods: {
    goBack () {
      if (!this.timerButton) {
        this.step = 0
        this.lockButton = false
        this.timerButton = false
        this.onCaptchaExpired()
        this.onSecondCaptchaExpired()
        clearInterval(this.timerInterval)
      }
    },
    startTimer () {
      this.timer = 90
      this.timerInterval = setInterval(() => {
        if (this.timer > 0) {
          this.timer--
        } else {
          this.timerButton = false
          clearInterval(this.timerInterval)
        }
      }, 1000)
    },
    clearCountdownTimer () {
      clearInterval(this.countdownTimer)
      this.countdownTimer = null
    },
    // Вызов капчи
    validateCapcha () {
      this.$refs.recaptcha.execute()
    },
    validateSecondCapcha () {
      this.$refs.recaptcha2.execute()
    },
    onCaptchaExpired () {
      this.$refs.recaptcha.reset()
    },
    onSecondCaptchaExpired () {
      this.$refs.recaptcha2.reset()
    },
    async sendSMS (recaptchaToken) {
      try {
        this.lockButton = true
        this.clearCountdownTimer()
        const phoneItem = await this.$user.updatePhone(this.phoneValue)

        // Determine the mobile operator based on the phone number
        let mobileOperator = 'other' // Default value for other operators

        // Check if the phone number belongs to Kcell, Beeline KZ, or Beeline Belarus

        const prefix = phoneItem.phone.substring(0, 3) // Extract the prefix
        console.log(prefix)
        if (prefix === '770' || prefix === '770' || prefix === '770') {
          mobileOperator = 'Kcell'
        } else if (prefix === '770' || prefix === '770' || prefix === '770') {
          mobileOperator = 'Beeline KZ'
        } else if (prefix === '375') {
          mobileOperator = 'Beeline Belarus'
        }

        if (
          mobileOperator === 'Kcell' ||
          mobileOperator === 'Beeline KZ' ||
          mobileOperator === 'Beeline Belarus'
        ) {
          const params = new URLSearchParams()
          params.append('phone', phoneItem.phone)
          params.append('email', this.user.email)

          const url = '/resend_code?' + params.toString()

          try {
            await this.$emit('resend-code', url)
          } catch (error) {
            console.log(123215)
          }
        } else {
          // For other operators, proceed with sending the SMS
          const resp = await this.$user.validatePhoneRequest(recaptchaToken)
          if (resp.code === 'Token assessment has been failed for the reason: invalid-keys') {
            this.$toast.error(
              'Произошла ошибка при верификации номера. Пожалуйста, попробуйте еще раз.'
            )
            throw new Error(resp.code)
          }
        }
        this.step = 1
        this.countdown = 120
        this.countdownTimer = setInterval(() => {
          this.countdown--
        }, 1000)
      } catch (e) {
        console.log(e.toString())
        console.log(e)
        console.error(e)
      }
      this.logActionEvent('sms_fetch_code')
    },
    async sendVerificationCode () {
      let resp = {}
      try {
        resp = await this.$user.validatePhone(this.codeValue)
        if (!resp.ok) {
          const result = await resp.json()
          switch (result.code) {
            case 'phone.validation.code.is.already.expired':
              this.errorText = this.$bimTranslate(
                'phoneValidate.error.codeIsAlreadyExpired',
                this.activeLang
              )
              break
            case 'phone.validation.code.is.incorrect':
              this.errorText = this.$bimTranslate(
                'phoneValidate.error.codeIsIncorrect',
                this.activeLang
              )
              break
            case 'phone.is.already.validated':
              this.errorText = this.$bimTranslate(
                'phoneValidate.error.alreadyValidated',
                this.activeLang
              )
              break
            default:
              this.errorText = this.$bimTranslate(
                'phoneValidate.error.unknownError',
                this.activeLang
              )
          }
        }
      } catch (e) {
        console.error(e)
      }
      if (resp.ok) {
        this.errorText = ''
        this.step = 2
        /**
         * успешное подтверждение телефона
         */
        this.$emit('success')
        this.logActionEvent('sms_send_code')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.refresh {
  color: #00afa1;
  cursor: pointer;
  text-decoration: underline;
  &:hover {
    text-decoration: none;
  }
}

.buttons {
  display: flex;
  &__item {
    flex: 1;
    padding: 0 17px;
  }
}

.phone::v-deep .bim-input label {
  display: none;
}

.agreement {
  font-size: 14px;

  a {
    color: #00afa1;
  }
}
</style>
